import React, { useState } from 'react';
import MarketingLayout from '../components/MarketingLayout';
import { Link } from 'react-router-dom';
import '../marketing.css';

const ClubsFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "1. What is PlayBack Token?",
      answer: "PlayBack Token is a platform that helps community groups, sports clubs, and charities turn their volunteer work into verified digital records. These records, called tokens, can be sold to companies looking to support community impact as part of their ESG commitments. When a company buys your verified hours, 90% of the money goes straight to your club."
    },
    {
      question: "2. How does our club get started?",
      answer: (
        <>
          Your club simply applies to join on our Website by clicking{' '}
          <Link to="/clubs#contact" style={{color: 'var(--primary-red)', textDecoration: 'underline', fontWeight: 600}}>
            here
          </Link>
          {' '}- we will then guide you through the approval process. Once approved, you'll receive a unique link to invite your volunteers and supervisors. Supervisors verify volunteer hours, and PlayBack Token handles the rest — turning approved hours into verified impact that companies can purchase.
        </>
      )
    },
    {
      question: "3. How does the payment process work?",
      answer: "When a company buys a bundle of verified volunteer hours, PlayBack Token automatically tracks the transaction. Your club receives 90% of the payment directly into your Stripe Connect Account and 10% goes to the platform to keep things running. Payments are transparent and visible in your club dashboard."
    },
    {
      question: "4. How do volunteer hours become tokens?",
      answer: "After volunteers log their hours and supervisors approve them, PlayBack Token verifies the data and converts each hour into a blockchain token — a digital proof of the work done. These tokens cannot be traded or sold by anyone else (they are non-transferable), keeping the record fully authentic."
    },
    {
      question: "5. What kind of volunteer work qualifies?",
      answer: "Any genuine, unpaid work done for the community through your club — coaching, maintenance, event setup, administration, fundraising, or community outreach — can qualify. Supervisors and admins ensure the hours are real and appropriate before approval."
    },
    {
      question: "6. How can we track which companies supported us?",
      answer: "Once your hours are sold, your dashboard shows which companies purchased them and how much they contributed. Volunteers can also see which company supported their specific hours."
    },
    {
      question: "7. Is the system secure and GDPR compliant?",
      answer: "Yes. The platform follows best practices for data security and complies with GDPR standards. Only approved personnel see volunteers' names. Companies that buy tokens see anonymised activity data, not personal identities."
    },
    {
      question: "8. Is there a cost to join?",
      answer: "No. PlayBack Token is completely free for clubs and community groups to join and use. The only fee is 10% of each transaction, which is automatically deducted when a company purchases your verified hours. There are no setup fees, no monthly costs, and no hidden charges."
    }
  ];

  return (
    <MarketingLayout>
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="container">
          <h1>Clubs & Community Groups FAQ</h1>
          <p>Everything you need to know about turning volunteer work into verified impact</p>
        </div>
      </section>

      {/* FAQ Content */}
      <div className="faq-container">
        <Link to="/clubs" className="back-link">← Back to Clubs Page</Link>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span className="faq-question-text">{faq.question}</span>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </button>
              <div className={`faq-answer ${openIndex === index ? 'active' : ''}`}>
                <div className="faq-answer-content">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MarketingLayout>
  );
};

export default ClubsFAQ;
